import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IActivityType, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVTextArea } from "../../shared/JVTextarea";
import { JVMultiselect } from "../../shared/JVMultiselect";

const schema = yup.object({
    name: yup.string().trim().required("ActivityType is required"),
    icon: yup.string().trim().required("Icon is required")
});

interface Iprops {
    singleData: IActivityType,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

interface IParamDrop extends IDropdown {
    type: string,
    isRequired: boolean,
    forRequirement: boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [params, setParams] = useState<IParamDrop[]>();
    const [selectedParamsA, setSelectedParamsA] = useState<IParamDrop[]>();
    const [selectedParamsR, setSelectedParamsR] = useState<IParamDrop[]>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IActivityType>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.paramIds && props.singleData.paramIds.length > 0) {
            setSelectedParamsA(params?.filter(p => !p.forRequirement && props.singleData.paramIds?.includes(p.id)));
            setSelectedParamsR(params?.filter(p => p.forRequirement && props.singleData.paramIds?.includes(p.id)));
        } else {
            const spa = params?.filter(a => a.forRequirement === false && (a.name === 'Occupancy' || a.name === 'Price'));
            const spr = params?.filter(a => a.forRequirement === true && (a.name === 'Adults' || a.name === 'Children'));
            setSelectedParamsA(spa);
            setSelectedParamsR(spr);
        }
    }, [props.singleData]);

    const saveToDB = async (body: IActivityType) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const occupancy = selectedParamsA?.some(a => a.name === 'Occupancy');
        const price = selectedParamsA?.some(a => a.name === 'Price');

        if (!occupancy || !price) {
            props.toast.current.show({ severity: 'error', detail: 'Occupancy and Price are necessory with Parameters(A)', life: 3000 });
            setSubmitting(false);
            return;
        }

        const adults = selectedParamsR?.some(a => a.name === 'Adults');
        const children = selectedParamsR?.some(a => a.name === 'Children');

        if (!adults || !children) {
            props.toast.current.show({ severity: 'error', detail: 'Adults and Children are necessory with Parameters(R)', life: 3000 });
            setSubmitting(false);
            return;
        }

        body.paramIds = [
            ...(selectedParamsA?.map(s => s.id) || []),
            ...(selectedParamsR?.map(s => s.id) || [])
        ];

        const response = await Fetch(`ActivityType${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        setSelectedParamsA(undefined);
        setSelectedParamsR(undefined);
        reset({});
        props.hideDialog();
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    const loadParams = async () => {
        const response = await Fetch(`ParameterMast/dropdown`, "GET", null, null, null);
        if (response) {
            const d: IParamDrop[] = await response.json();
            setParams(d);
        }
    }

    useEffect(() => { loadParams(); }, []);

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit ActivityType" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={1} required label="ActivityType Name" control={control} name="name" error={errors.name?.message} />
                <JVInput column={1} required label="ActivityType Icon" control={control} name="icon" error={errors.icon?.message} />
                <JVMultiselect value={selectedParamsA} column={1} label="Parameters(A)" options={params?.filter(f => !f.forRequirement)} onChange={setSelectedParamsA} optionLabel="name" placeholder="Select Parameters" />
                <JVMultiselect value={selectedParamsR} column={1} label="Parameters(R)" options={params?.filter(f => f.forRequirement)} onChange={setSelectedParamsR} optionLabel="name" placeholder="Select Parameters" />
                <JVTextArea column={1} label="Description" control={control} name="description" error={errors.description?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}